import { wafflesKeyColumnName } from "@app/shared/waffles";
import InspectionProfileTableData from "@app/projects/servicing-provider/accuracy/provider-inspection-profile-components/inspectionProfileTableData";
import { valueOrDashes } from "@app/projects/servicing-provider/accuracy/provider-inspection-profile-components/utils";
import { QesIcon } from "@app/shared/icons/QESIcon";
import { QesIcons } from "@app/shared/icons/qesIcons";
import TooltipWrapper from "@app/shared/TooltipWrapper";

// have to disable sort-keys here until we can change how the table data is generated on the panel.

/* oxlint-disable sort-keys */
export const generateAdditionalKnownSpecialtyProviderPanelRows = (rowKey: string, title: string, additionalSpecialties: string[], tooltipText = "Based on NPI"): InspectionProfileTableData => {
  return {
    [wafflesKeyColumnName]: rowKey,
    title: (
      <TooltipWrapper text={tooltipText} position="bottom">
        {title}
      </TooltipWrapper>
    ),
    source: generateRowSource(additionalSpecialties),
    result: generateRowResults(),
    reference: <>{"---"}</>,
    attesterInfo: <>{"---"}</>,
    attestationMethod: <>{"---"}</>
  };
}

const generateRowSource = (additionalSpecialties: string[]) => {
  return (additionalSpecialties && additionalSpecialties.length > 0) ?
    (additionalSpecialties.map((additionalKnownSpecialty, index) => {
      return (
        <div key={index}>
          <div>
            {valueOrDashes(additionalKnownSpecialty)}
          </div>
        </div>
      );
    })) :
    valueOrDashes(null)
}

const generateRowResults = () => {
  return (
    <span className="text-muted">
      <QesIcon iconName={QesIcons.Help} description="The accuracy of this information is unknown" className="mx-2 align-text-top" />
    </span>
  );
}